import React from "react";
import { FooterConfig, NavbarScreen, SupportScreen } from "../../components";
import RegisterUserForm from "./components/RegisterUserForm";

const RegisterUserScreen = () => {
  return (
    <>
      <NavbarScreen />
      <div className="RegisterUser container">
        <div className="row">
          <div className="content__left col-md-9 col-sm-12 p-0">
            <h1 className="content__title--one"> Đăng kí tài khoản</h1>

            <RegisterUserForm />
          </div>
          <div className="content__right col-md-3 col-sm-12 pr-0">
            <SupportScreen />
          </div>
        </div>
      </div>

      <FooterConfig />
    </>
  );
};

export default RegisterUserScreen;
